import ComboNavLink from '@/components/Combo/ComboNavLink/ComboNavLink'
import Container from '@/components/Container/Container'
import DefaultHead from '@/components/DefaultHead/DefaultHead'
import Main from '@/components/Main/Main'
import RelatedInfo from '@/components/RelatedInfo/RelatedInfo'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'
import { CombosPageProps } from '@/types/page'
import { serverSidePropsFor } from '@/utils/helpers.server'

const THASSAS_ORACLE_UID = '726e8b29-13e9-4138-b6a9-d2a0d8188d1c'
const PEER_INTO_THE_ABYSS_UID = 'aac00055-640e-4749-8d23-d242e6d0b23a'

const CombosPage = ({ data }: CombosPageProps) => (
  <Main>
    <Container>
      <DefaultHead data={data} />
      <SimpleHeader>Bracket Relevant Combos</SimpleHeader>
      <div className='d-flex gap-2 flex-wrap mb-4'>
        <ComboNavLink
          cornerImageUid={THASSAS_ORACLE_UID}
          description='Voted by the community as true, 2-card combos that can be executed in the early game. Only for Brackets 4 and 5.'
          icon='boltLightning'
          title='Early Game 2-Card Combos'
          url='/combos/early-game-2-card-combos'
        />
        <ComboNavLink
          cornerImageUid={PEER_INTO_THE_ABYSS_UID}
          description='Voted by the community as true, 2-card combos that are not typically executable in the early game. Only for Brackets 3, 4 and 5.'
          icon='clock'
          title='Late Game 2-Card Combos'
          url='/combos/late-game-2-card-combos'
        />
      </div>
      <SimpleHeader>Combos by Color</SimpleHeader>
      <RelatedInfo relatedInfo={data.related_info} textRightSuffix='combos' />
    </Container>
  </Main>
)

export const getServerSideProps = async () =>
  serverSidePropsFor(`${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/pages/combos.json`)

export default CombosPage
